import { AxiosInstance } from 'axios'
import { Ambiente } from './ambiente'

export class AmbienteRepository {
    constructor(private api: AxiosInstance) { }

    async getById(codigo_condominio: number, id: number): Promise<Ambiente> {
        const { data } = await this.api.get<Ambiente>(`condominios/${codigo_condominio}/ambientes/${id}`)
        return data
    }

    async getByCodigoCondominio(codigo_condominio: number): Promise<Ambiente[]> {
        const { data } = await this.api.get<Ambiente[]>(`condominios/${codigo_condominio}/ambientes`)
        return data
    }

    async save(ambiente: Ambiente): Promise<Ambiente> {
        const { data } = await this.api.post<Ambiente>(`condominios/${ambiente.condominio_id}/ambientes/${ambiente.id}`, {
            ...ambiente
        })

        return data
    }
}